import { ResourceOptions } from 'react-admin';
import { FaDollarSign } from 'react-icons/fa';
import { Resources } from '../../resource';

import './dataProvider';

export { default as list } from './List';

export const name = Resources.blindBoxRewardFeedUsdc;
export const icon = FaDollarSign;
export const options: ResourceOptions = {
  label: 'module.blindBox.rewardFeedUsdc',
};
